import { labelKeys } from '@/utils/designUtils'
export default {
  methods: {
    resetLabelByLanguage(design, languageMap) {
      if (!design) {
        return
      }
      if ((design instanceof Array) && design.length > 0) {
        design.forEach(e => {
          this.resetLabelByLanguage(e, languageMap)
        })
        return
      }
      if (!(design instanceof Object)) {
        return
      }
      const keys = Object.keys(design)
      keys.forEach(k => {
        let v = design[k]
        if ((v instanceof Array) || (v instanceof Object)) {
          this.resetLabelByLanguage(v, languageMap)
          return
        }
        if (labelKeys.indexOf(k) >= 0) {
          if (!v || typeof(v) !== 'string') {
            return
          }
          if (v.startsWith('!')) {
            v = v.replace('!', '')
            design[k] = v
            return
          }
          if (v.startsWith('${')) {
            return
          }
          // if (v.startsWith('#!')) {
          //   v = v.replace('#', '')
          // }
          // if (v.match(/^[##]+!/g)) {
          //   let str = v
          //   while (str.startsWith('##')) {
          //     str = str.replace('##', '')
          //     v = v.replace('##', '#')
          //   }
          // }
          const lang = this.$store.getters.lang.lang
          // v = ("${GET(" + (lang === 'en-US' ? 'enUS' : 'zhCN') + ", '" + v + "', '" + v + "')}")
          if (languageMap) {
            const map = languageMap[`${lang === 'en-US' ? 'enUS' : 'zhCN'}`] || {}
            v = map[v] || v
          }
          design[k] = v
        }
      })
    },
    getLanguageMap(design) {
      if (!design) {
        return null
      }
      let zhCN = {}
      let enUS = {}
      if ((design instanceof Array) && design.length > 0) {
        design.forEach(e => {
          const r = this.getLanguageMap(e)
          zhCN = { ...zhCN, ...r?.zhCN }
          enUS = { ...enUS, ...r?.enUS }
        })
        return {zhCN, enUS}
      }
      if (!(design instanceof Object)) {
        return null
      }
      const data = design.data
      if (data) {
        zhCN = { ...zhCN, ...data.zhCN }
        enUS = { ...enUS, ...data.enUS }
      }
      if (design.body) {
        const r = this.getLanguageMap(design.body)
        zhCN = { ...zhCN, ...r?.zhCN }
        enUS = { ...enUS, ...r?.enUS }
      }
      return {zhCN, enUS}
    }
  },
}